import { Doc } from 'tiptap'

export default class SingleLineDoc extends Doc {
  get schema() {
    return {
      content: 'singleLineEditable',
    }
  }
}
